// @ts-nocheck
import React, { useEffect, useState } from 'react';
import './styles.css'
import Navbar from './components/Navbar';
import Footer from './components/Footer';

import NotificationToast from './components/notification/NotificationToast';
import { dynamicLoader } from '../helpers/helpers';
import CosmicOrbitLoader from '../components/CosmicOrbitLoader';
import PrivacyPolicy from './components/sections/PrivacyPolicy';
import { Helmet } from "react-helmet";

const PrivacyPolicyPage = () => {
  const [showPreloader, setShowPreloader] = useState(true);

  document.title = "Webs2PDF";
  useEffect(() => {
    dynamicLoader.addScripts();
    setTimeout(() => {
      setShowPreloader(false);
    }, 500);
  });
  if (showPreloader) {
    return <CosmicOrbitLoader />;
  }
  return (
    <>
     <Helmet>
        <title>Privacy Policy – Webs2PDF | Your Data, Protected</title>
        <meta
          name="title"
          content="Privacy Policy – Webs2PDF | Your Data, Protected"
        />
        <meta
          name="description"
          content="Learn how Webs2PDF collects, stores, and protects your personal data. We value your privacy and ensure full compliance with data protection regulations."
        />
        <link rel="canonical" href="https://webs2pdf.com/privacy-policy" />
        <meta name="description" content="" data-react-helmet="true" />
      </Helmet>
      <NotificationToast />
      <Navbar />
      <PrivacyPolicy />
      <Footer />
    </>
  );
}
export default PrivacyPolicyPage;
